/**
 * WW Combo Switch Attach — inline attach row for push-button COMBO
 * plates on the default product template.
 *
 * One switch per PUSH OPENING (data-openings, default 1) — never per
 * gang. Checked by default; rewrites the main button price to the
 * combined "with N switches" grammar and posts both line items on add.
 *
 * Sibling of push-button-switch-upsell.js (pushplate accordion) —
 * kept separate on purpose: that widget's per-gang math is wrong for
 * combos.
 */
(function () {
  'use strict';

  var SWITCH_HANDLE = 'the-push-button-switch';

  var switchProduct = null;
  var switchVariant = null;
  var openings = 1;
  var attachActive = false;
  var platePrice = 0;
  var plateTitle = '';
  var plateImageSrc = '';
  var switchImageSrc = '';

  var rowEl = null;
  var checkboxEl = null;
  var mainBtnEl = null;
  var mainBtnTextEl = null;
  var mainBtnPriceEl = null;
  var qtyInput = null;
  var savedBtnPrice = '';

  function init() {
    var sourceEl = document.getElementById('wwComboAttachSource');
    if (!sourceEl) return;

    var productInner = document.querySelector('.product__inner[data-product-form-wrapper]');
    if (!productInner) return;

    openings = parseInt(sourceEl.dataset.openings, 10) || 1;
    plateTitle = sourceEl.dataset.plateTitle || '';
    platePrice = parseInt(sourceEl.dataset.currentVariantPrice, 10) || 0;
    plateImageSrc = sourceEl.getAttribute('data-plate-image') || '';
    switchImageSrc = sourceEl.getAttribute('data-switch-image') || '';
    sourceEl.remove();

    mainBtnEl = productInner.querySelector('[data-add-to-cart]');
    mainBtnTextEl = productInner.querySelector('[data-add-to-cart-text]');
    mainBtnPriceEl = productInner.querySelector('[data-button-price]');
    qtyInput = productInner.querySelector('[data-quantity-input]');
    if (!mainBtnEl || !mainBtnPriceEl) return;

    rowEl = document.createElement('div');
    rowEl.className = 'ww-combo-attach';
    rowEl.innerHTML =
      '<label class="ww-combo-attach__cb">' +
        '<input type="checkbox" checked>' +
        '<span class="ww-combo-attach__box"></span>' +
      '</label>' +
      (switchImageSrc ? '<span class="ww-combo-attach__thumb"><img src="' + switchImageSrc + '" alt="" loading="lazy"></span>' : '') +
      '<span class="ww-combo-attach__text">Add the push button switch it needs' +
        '<span class="ww-combo-attach__sub">' + (openings === 1 ? 'One switch per push opening' : openings + ' switches — one per push opening') + '</span>' +
      '</span>' +
      '<span class="ww-combo-attach__price" data-ww-attach-price></span>';

    var qtyBlock = productInner.querySelector('.product__block__quantity');
    var buttonsBlock = productInner.querySelector('.product__block__buttons');
    var insertBefore = qtyBlock || buttonsBlock;
    if (insertBefore) {
      insertBefore.before(rowEl);
    } else {
      productInner.appendChild(rowEl);
    }

    checkboxEl = rowEl.querySelector('input');
    checkboxEl.addEventListener('change', function () {
      if (checkboxEl.checked) activate();
      else deactivate();
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', reassertLater);
      qtyInput.addEventListener('change', reassertLater);
    }

    var productSection = rowEl.closest('[data-section-type]') || productInner.closest('[data-section-type]') || document;
    productSection.addEventListener('theme:variant:change', onVariantChange);

    fetch('/products/' + SWITCH_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) {
          rowEl.remove();
          return;
        }
        switchProduct = p;
        switchVariant = p.variants[0];
        rowEl.querySelector('[data-ww-attach-price]').textContent = '+ ' + formatMoney(switchVariant.price * openings);
        activate();
      })
      .catch(function () { rowEl.remove(); });
  }

  function mainQty() {
    return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  }

  function switchCount() {
    return openings * mainQty();
  }

  function applyPrice() {
    if (!attachActive || !switchVariant || !mainBtnPriceEl) return;
    var total = (platePrice + switchVariant.price * openings) * mainQty();
    var n = switchCount();
    mainBtnPriceEl.textContent = formatMoney(total) + ' · with ' + n + (n === 1 ? ' switch' : ' switches');
  }

  function reassertLater() {
    // run AFTER the theme's own price update
    setTimeout(applyPrice, 50);
  }

  function activate() {
    if (!switchVariant || !mainBtnEl) return;
    if (!attachActive) {
      savedBtnPrice = mainBtnPriceEl.textContent.trim();
      attachActive = true;
    }
    applyPrice();
    mainBtnEl.removeEventListener('click', interceptClick, true);
    mainBtnEl.addEventListener('click', interceptClick, true);
  }

  function deactivate() {
    if (!attachActive) return;
    attachActive = false;
    if (mainBtnPriceEl) mainBtnPriceEl.textContent = savedBtnPrice;
    if (mainBtnEl) mainBtnEl.removeEventListener('click', interceptClick, true);
  }

  function onVariantChange(e) {
    if (!e.detail || !e.detail.variant) return;
    if (e.detail.variant.price) platePrice = e.detail.variant.price;
    if (e.detail.variant.featured_image && e.detail.variant.featured_image.src) {
      plateImageSrc = e.detail.variant.featured_image.src.replace(/\?.*/, '') + '?width=80';
    }
    if (attachActive) {
      savedBtnPrice = formatMoney(platePrice * mainQty());
      reassertLater();
    }
  }

  function interceptClick(e) {
    if (!attachActive) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addBoth();
  }

  function addBoth() {
    var formInput = document.querySelector('form[data-product-form] input[name="id"]');
    var plateVariantId = formInput ? parseInt(formInput.value, 10) : null;
    if (!plateVariantId || !switchVariant) return;

    mainBtnEl.classList.add('loading');
    mainBtnEl.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: plateVariantId, quantity: mainQty() },
          { id: switchVariant.id, quantity: switchCount() }
        ]
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      return r.json();
    })
    .then(function () {
      mainBtnEl.classList.remove('loading');
      mainBtnEl.classList.add('has-success');
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
          showPopdown();
        });
      setTimeout(function () {
        mainBtnEl.classList.remove('has-success');
        mainBtnEl.disabled = false;
      }, 3000);
    })
    .catch(function () {
      mainBtnEl.classList.remove('loading');
      mainBtnEl.disabled = false;
      if (mainBtnTextEl) {
        var saved = mainBtnTextEl.textContent;
        mainBtnTextEl.textContent = 'Error — try again';
        setTimeout(function () { mainBtnTextEl.textContent = saved; }, 2500);
      }
    });
  }

  function showPopdown() {
    var popdownEl = document.querySelector('[data-product-add-popdown-wrapper]');
    if (!popdownEl) return;

    var n = switchCount();
    var switchLabel = n === 1 ? '1 Push Button Switch' : n + ' Push Button Switches';
    var plateLabel = mainQty() === 1 ? '1 × ' + plateTitle : mainQty() + ' × ' + plateTitle;
    var imagesHtml = (plateImageSrc ? '<img src="' + plateImageSrc + '" alt="">' : '') +
                     (plateImageSrc && switchImageSrc ? '<span class="plate-picker-popdown__plus">+</span>' : '') +
                     (switchImageSrc ? '<img src="' + switchImageSrc + '" alt="">' : '');

    popdownEl.innerHTML =
      '<div class="product__popdown__outer" role="alertdialog" aria-labelledby="dialogTitle">' +
        '<div class="product__popdown__textbar">' +
          '<span class="product__popdown__title product__popdown__title--bold">Added &mdash; </span>' +
          '<span class="product__popdown__title">' + plateLabel + ' + ' + switchLabel + '</span>' +
        '</div>' +
        '<div class="wrapper !my-auto">' +
          '<div class="product__popdown__inner">' +
            '<div class="product__popdown__close">' +
              '<button class="popdown__close__inner" aria-label="Close" data-close-popdown>' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="2" y1="2" x2="14" y2="14"/><line x1="14" y1="2" x2="2" y2="14"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="product__popdown__image plate-picker-popdown__images">' + imagesHtml + '</div>' +
            '<div class="product__popdown__cart__wrapper">' +
              '<a href="/cart" class="product__popdown__cart btn-text-thick-line" data-drawer-toggle="drawer-cart">View cart</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    popdownEl.classList.add('is-visible');
    var closeBtn = popdownEl.querySelector('[data-close-popdown]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popdownEl.classList.remove('is-visible');
      });
    }
    setTimeout(function () {
      popdownEl.classList.remove('is-visible');
    }, 5000);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
